/**
 * Detecting experience editor using Sitecore's global javascript namespace
 * - https://mattneil.co.uk/2016/12/08/detect-sitecore-page-modes/
 * - need typeof for specific circumstances
 */
export default !!(
    typeof window.Sitecore !== "undefined" && 
    typeof window.Sitecore.PageModes !== "undefined" && 
    typeof window.Sitecore.PageModes.PageEditor !== "undefined"
);
